export const AUCTION_BLOCKER_MODIFIED = 'auction.blocker.modified';
export const AUCTION_BLOCKER_RUNNING_PHASE = 'auction.blocker.running';
export const AUCTION_BLOCKER_CLOSED_PHASE = 'auction.blocker.closed';
export const AUCTION_BLOCKER_TERMINAL_PHASE = 'auction.blocker.terminalPhase';
export const AUCTION_BLOCKER_QUANTITY_NOT_REACHED = 'auction.blocker.quantityNotReached';
export const AUCTION_BLOCKER_DEVIATION_LIMIT_MISSING = 'deviationLimitMissing';
export const AUCTION_BLOCKER_MISSING_PRODUCT = 'auction.blocker.missingProduct';
export const AUCTION_BLOCKER_MISSING_ZONE = 'auction.blocker.missingZone';
export const AUCTION_BLOCKER_MISSING_TECHNICAL_AUCTIONEER = 'auction.blocker.missingTechnicalAuctioneer';

export const transformAuctionBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case AUCTION_BLOCKER_MODIFIED:
            result = t('auctions.blocker.auction-modified');
            break;
        case AUCTION_BLOCKER_RUNNING_PHASE:
            result = t('auctions.blocker.auction-in-running-phase');
            break;
        case AUCTION_BLOCKER_CLOSED_PHASE:
            result = t('auctions.blocker.auction-in-closed-phase');
            break;
        case AUCTION_BLOCKER_TERMINAL_PHASE:
            result = t('auctions.blocker.auction-in-terminal-phase');
            break;
        case AUCTION_BLOCKER_QUANTITY_NOT_REACHED:
            result = t('auctions.blocker.auction-quantity-not-reached');
            break;
        case AUCTION_BLOCKER_DEVIATION_LIMIT_MISSING:
            result = t('auctions.blocker.auction-deviation-limit-missing');
            break;
        case AUCTION_BLOCKER_MISSING_PRODUCT:
            result = t('auctions.blocker.missing-product');
            break;
        case AUCTION_BLOCKER_MISSING_ZONE:
            result = t('auctions.blocker.missing-zone');
            break;
        case AUCTION_BLOCKER_MISSING_TECHNICAL_AUCTIONEER:
            result = t('auctions.blocker.missing-technical-auctioneer');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
